var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsAndConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.25V18.75H6.75V17.25H5.25V3.75H15V4.5H16.5V2.25H3.75ZM7.5 5.25V6V21.75H20.25V5.25H7.5ZM9 6.75H18.75V20.25H9V6.75ZM10.5 9.75V11.25H17.25V9.75H10.5ZM10.5 12.75V14.25H17.25V12.75H10.5ZM10.5 15.75V17.25H17.25V15.75H10.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsAndConditions);
export default __webpack_public_path__ + "static/media/terms-and-conditions.7d26f4ff4da536f427e8adf56699d5b2.svg";
export { ForwardRef as ReactComponent };